import { useEffect } from 'react';
import { useLocation } from 'react-router';
import ReactPixel from 'services/facebookPixel';
import { logAnalytics } from 'utils/logAnalytics';

const useRouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    ReactPixel.pageView();
    logAnalytics('screen_view', { page_path: pagePath });
    logAnalytics('page_view', { page_path: pagePath });
  }, [location]);
  return null;
};

export default useRouteAnalytics;
